<template>
  <div>
    <loading :active.sync="isLoading" color="#85344c"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/uniodonto/oportunidades"
              >Oportunidades</router-link
            >
          </li>
          <li class="breadcrumb-item active">Detalhes da Oportunidade</li>
        </ol>

        <!-- Dados usuário-->
        <div class="delete-item">
          <h4 @click="deletarOportunidade">Deletar oportunidade</h4>
        </div>
        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2><i class="fa fa-info"></i>Dados do contratante</h2>
          </div>
          <div class="row">
            <div class="col-md-2">
              <div class="form-group">
                <label>Nome</label>
                <input
                  v-model="assinante.name"
                  class="form-control"
                  placeholder="Nome"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Sobrenome</label>
                <input
                  v-model="assinante.last_name"
                  class="form-control"
                  placeholder="Sobrenome"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Telefone</label>
                <input
                  class="form-control"
                  v-mask="'(##) 9####-####'"
                  type="tel"
                  v-model="assinante.telefone"
                  @blur="
                    (e) => {
                      if (e.target.value.split(' ')[1]) {
                        assinante.phones.number = e.target.value
                          .split(' ')[1]
                          .replace('-', '');
                        assinante.phones.area_code = e.target.value
                          .split(' ')[0]
                          .replace(/[^0-9]/g, '');
                      } else if (e.target.value === '') {
                        assinante.phones.number = '';
                        assinante.phones.area_code = '';
                      }
                    }
                  "
                  placeholder="Telefone"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>CPF</label>
                <input
                  class="form-control"
                  type="tel"
                  v-mask="'###.###.###-##'"
                  placeholder="CPF"
                  v-model="assinante.cpf"
                  @blur="
                    (e) =>
                      (assinante.cpf = e.target.value.replace(/[^0-9]/g, ''))
                  "
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label>E-mail</label>
                <input
                  v-model="assinante.email"
                  class="form-control"
                  placeholder="E-mail"
                  readonly
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Senha</label>
                <input
                  class="form-control"
                  type="password"
                  placeholder="Senha"
                />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>CEP</label>
                <input
                  class="form-control"
                  v-mask="'#####-###'"
                  v-model="assinante.zip_code"
                  type="tel"
                  @blur="(e) => getAddress(e.target.value)"
                  placeholder="CEP"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Cidade</label>
                <input
                  class="form-control"
                  v-model="assinante.city"
                  readonly
                  placeholder="Cidade"
                />
              </div>
            </div>
            <div class="col-md-1">
              <div class="form-group">
                <label>Estado</label>
                <input
                  class="form-control"
                  v-model="assinante.state"
                  readonly
                  placeholder="Estado"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label>Bairro</label>
                <input
                  class="form-control"
                  v-model="assinante.district"
                  placeholder="Bairro"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Rua</label>
                <input
                  class="form-control"
                  v-model="assinante.street"
                  placeholder="Rua"
                />
              </div>
            </div>
            <div class="col-md-1">
              <div class="form-group">
                <label>Número</label>
                <input
                  class="form-control"
                  type="number"
                  placeholder="N.º"
                  v-model="assinante.street_number"
                />
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <label>Complemento</label>
                <input
                  class="form-control"
                  v-model="assinante.complement"
                  placeholder="Complemento"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <p>
                <button
                  href="#0"
                  class="btn_1 medium pull-right btn-color flex align-items-center justify-content-center"
                  @click="editUser"
                >
                  Salvar <i class="fa fa-check ml-3"></i>
                </button>
              </p>
            </div>
          </div>
        </div>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2><i class="fa fa-users"></i>Participantes</h2>
          </div>

          <template >
            <div v-for="(participante, index) in participantes" :key="index">
              <p class="flex justify-content-between cursor-pointer">
                <b class="badge-item">Participante {{ index + 1 }} </b>
                <i
                  @click="() => deletarParticipante(index)"
                  class="fa fa-times badge-item"
                ></i>
              </p>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Nome</label>
                    <input
                      v-model="participantes[index].name"
                      class="form-control"
                      placeholder="Nome"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Data de nascimento</label>
                    <input
                      class="form-control"
                      v-mask="'##/##/####'"
                      placeholder="Nascimento"
                      v-model="participantes[index].birth_date"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>CPF</label>
                    <input
                      class="form-control"
                      v-mask="'###.###.###-##'"
                      placeholder="CPF"
                      v-model="participantes[index].cpf"
                      @blur="
                        (e) =>
                          (participantes[index].cpf = e.target.value.replace(
                            /[^0-9]/g,
                            ''
                          ))
                      "
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>E-mail</label>
                    <input
                      v-model="participantes[index].email"
                      class="form-control"
                      placeholder="E-mail"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label>RG</label>
                    <input
                      v-model="participantes[index].rg"
                      class="form-control"
                      placeholder="RG"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Parentesco</label>
                    <input
                      v-model="participantes[index].parentesco"
                      class="form-control"
                      placeholder="Parentesco"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Nome da mãe</label>
                    <input
                      v-model="participantes[index].nome_mae"
                      class="form-control"
                      placeholder="Nome da mãe"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Plano</label>
                    <select
                      v-model="participantes[index].plan_id"
                      class="form-control"
                      @change="(e) => atualizaCarrinho(e.target.value, index)"
                    >
                      <option value="" selected disabled>Selecione o plano</option>
                      <option
                        v-for="plano in planosEscolher"
                        :key="plano.id"
                        :value="plano.id"
                      >
                        {{ plano.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <div class="row mt-3">
            <div class="col-md-12">
              <button
                @click="addParticipante"
                class="btn_1 medium"
              >
                <i class="fa fa-plus"></i> Adicionar participante
              </button>
            </div>
          </div>
        </div>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2><i class="fa fa-shopping-cart"></i>Carrinho</h2>
          </div>
          <ShoppingCarDetails :shoppingCar="shoppingCar" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  padronizaData,
  padronizaDataUS,
  tratamento_requisicao,
  alerta
} from "@/utils/util";
import { numberToCpf, toDate } from "@/utils/formater";
import funcoesGerais from "@/assets/js/funcoes.js";
import { ajax } from "@/utils/util";
import ShoppingCarDetails from '../../../components/ShoppingCarDetails.vue';

export default {
  components: { ShoppingCarDetails },
  mixins: [funcoesGerais],
  data() {
    return {
      isLoading: false,
      planos: [],
      planosEscolher: [],
      abrangencia: [],
      assinante: {},
      participantes: [],
      shoppingCar: {
        plans: [],
        total: 0,
        subtotal: 0,
        adesao: 0
      },
      plansList: [],
      plansCorretorId: [],
      qtdParticipantes: 0,
      carrinho: {
        plans: []
      }
    };
  },
  mounted() {
    this.isLoading = true;
    const user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
    if (user) {
      Promise.all([
        ajax("get", `/operadoras/${user.id_operadora}/planos`),
        ajax("get",`oportunidades_detalhes/${this.$route.params.id}`)
      ]).then(([planosRes, res]) => {
          let assinante = {
            ...res.data.assinante,
            ...res.data.usuario,
            ...{ telefone: res.data.telefone.area_code + res.data.telefone.number },
          };

          this.planosEscolher = planosRes.data;
          let planoId = this.planosEscolher[0].id;
          
          this.planos = res.data.planos;
          this.assinante = assinante;

          this.qtdParticipantes = res.data.dependentes.length;
          if (this.qtdParticipantes > 0) {
            this.participantes = res.data.dependentes;
            this.participantes.map((part) => {
              part.birth_date = padronizaData(part.birth_date);
              this.plansList.push(part.plan_id);
            });
            this.plansCorretorId = this.planosEscolher.map(plan => {return plan.id});
            this.plansCorretorId.map( planCorretorId => {
              const qtd = this.plansList.filter(id => id === planCorretorId).length;
              if (qtd > 0) {
                ajax("get", `/detalhes/plano/${planCorretorId}`)
                  .then((response) => {
                    this.shoppingCar.plans.push({...response.data.plano, qtd});
                    this.updateTotal_Subtotal_Adesao();
                    this.abrangencia = response.data.abrangencia;
                  })
                  .catch((err) => {
                    this.isLoading = false;
                    tratamento_requisicao(err, this);
                  });
              }
            })
          } else {
            ajax("get", `/detalhes/plano/${planoId}`)
              .then((response) => {
                this.abrangencia = response.data.abrangencia;
              })
              .catch((err) => {
                this.isLoading = false;
                tratamento_requisicao(err, this);
              });

            let particip = {
              plan_id: this.planosEscolher[0].id,
              name: "",
              birth_date: "",
              cpf: "",
              rg: "",
              email: "",
              parentesco: "",
              nome_mae: "",
              estado_civil: "",
              genero: "",
              cns: "",
              naturalidade: "",
            }
            this.participantes[0] = particip;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          tratamento_requisicao(err, this);
        });
    } else {
      this.$router.replace(this.$route.query.redirect || "/");
    }
  },
  methods: {
    updateTotal_Subtotal_Adesao() {
      let total = 0;
      let subtotal = 0;
      let adesao = 0;
      
      this.shoppingCar.plans.map( plan => {
          total += (plan.price * plan.qtd);
          adesao += (plan.setup_fee * plan.qtd)
      })
      subtotal = total + adesao;
      
      this.shoppingCar = {
        plans: this.shoppingCar.plans,
        total,
        subtotal,
        adesao
      }
    },

    deletarOportunidade(){
      let self = this;
      self.$swal.fire({
        position: "center",
        type: "warning",
        title: "Atenção",
        text: 'Deseja mesmo deletar essa oportunidade?',
        showCancelButton: true,
        showCancelButton: true,
        confirmButtonText: `Excluir`,
        cancelButtonText: `Cancelar`,
      }).then((result) => {
        if (!result.dismiss) {
          this.isLoading = true;
          const user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
          ajax("delete", `/operadoras/${user.id_operadora}/oportunidades/${self.$route.params.id}`)
          .then((response) => {
            this.isLoading = false;
            this.$swal.fire({
              position: "center",
              type: "success",
              title: "Oportunidade deletada com sucesso!",
              showConfirmButton: false,
            });
            self.$router.replace({path: '/uniodonto/oportunidades/'})
          })
          .catch((error) => {
            this.isLoading = false;
            tratamento_requisicao(error, this);
          });
        }
      })
    },

    editUser() {
      this.isLoading = true;
      let info_assinante = {
        birth_date: this.assinante.birth_date,
        city: this.assinante.city,
        complement: this.assinante.complement,
        country: this.assinante.country,
        cpf: this.assinante.cpf,
        district: this.assinante.district,
        email: this.assinante.email,
        last_name: this.assinante.last_name,
        name: this.assinante.name,
        state: this.assinante.state,
        street: this.assinante.street,
        street_number: this.assinante.street_number,
        zip_code: this.assinante.zip_code,
        phones: this.assinante.phones,
      };

      const user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
      ajax("put", `/operadoras/${user.id_operadora}/oportunidades/${this.$route.params.id}`, info_assinante)
        .then((res) => {
          this.isLoading = false;
          this.$swal.fire({
            position: "center",
            type: "success",
            title: "Dados atualizados com sucesso!",
            showConfirmButton: true,
          });
        })
        .catch((error) => {
          this.isLoading = false;
          tratamento_requisicao(error, this);
        });
    },

    atualizaCarrinho(planoId, index) {
      const planIndex = this.shoppingCar.plans.findIndex(plan => plan.id === parseInt(planoId));
      if (planIndex === -1) {
        ajax("get", `/detalhes/plano/${planoId}`)
          .then((response) => {
            this.shoppingCar.plans.push({...response.data.plano, qtd: 1});
            this.updateTotal_Subtotal_Adesao();
          })
          .catch((err) => {
            tratamento_requisicao(err, this);
          });
      } else {
        this.shoppingCar.plans[planIndex].qtd += 1;
        this.updateTotal_Subtotal_Adesao();
      }
    },

    getAddress(code) {
      this.isLoading = true;
      if (code.replace(/\D/g, "").length === 8) {
        ajax("get", `https://viacep.com.br/ws/${code.replace(/\D/g, "")}/json/`)
          .then((res) => {
            if (res.erro) {
              this.assinante.zip_code = '';
              this.assinante.city = '';
              this.assinante.district = '';
              this.assinante.state = '';
              this.assinante.street = '';
              this.assinante.street_number = '';
            } else {
              this.assinante.city = res.localidade;
              this.assinante.country = "BRA";
              this.assinante.district = res.bairro;
              this.assinante.state = res.uf;
              this.assinante.street = res.logradouro;

              let abrangente = false;
              this.abrangencia.map( cityAbrangencia => {
                if (this.assinante.city === cityAbrangencia.nome) {
                  abrangente = true;
                }
              })

              if (!abrangente) {
                this.$swal.fire({
                  position: "center",
                  type: "error",
                  title: "Erro ao encontrar a cidade",
                  text: "Esta cidade não faz parte da abrangência do plano.",
                  showConfirmButton: true,
                });

                this.assinante.zip_code = '';
                this.assinante.city = '';
                this.assinante.district = '';
                this.assinante.state = '';
                this.assinante.street = '';
                this.assinante.street_number = '';
              }
            };
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      } else {
        if (code.length > 0) {
          this.$swal.fire({
            position: "center",
            type: "warning",
            title: "Aviso",
            text: "Digite um CEP válido.",
            showConfirmButton: true,
          });
        }
        this.assinante.zip_code = '';
        this.assinante.city = '';
        this.assinante.district = '';
        this.assinante.state = '';
        this.assinante.street = '';
        this.assinante.street_number = '';
      }
    },
    addParticipante() {
      this.participantes.push({
        plan_id: "",
        name: "",
        birth_date: "",
        cpf: "",
        rg: "",
        email: "",
        parentesco: "",
        nome_mae: "",
        estado_civil: "",
        genero: "",
        cns: "",
        naturalidade: "",
      });
    },
    deletarParticipante(i) {
      this.isLoading = true;
      if (this.participantes.length > 1) {
        let dependente = this.participantes[i];
        if (dependente.id) {
          ajax("delete", `/dependentes/${dependente.id}`)
            .then( (res) => {
              this.participantes.splice(i, 1);
              this.qtdParticipantes = this.participantes.length;
              this.plansList.splice(i, 1);
              const index = this.shoppingCar.plans.findIndex(plan => plan.id === dependente.plan_id);
              if (this.shoppingCar.plans[index].qtd > 1) {
                this.shoppingCar.plans[index].qtd -= 1;
              } else {
                this.shoppingCar.plans.splice(index, 1);
              }
              this.updateTotal_Subtotal_Adesao();

              this.$swal.fire({
                position: "center",
                type: "success",
                title: "Sucesso",
                text: 'Participante deletado com sucesso.',
                showConfirmButton: true,
              });
              this.isLoading = false;
            })
            .catch((e) => {
              this.isLoading = false;
              tratamento_requisicao(e, this);
            });
        } else {
          this.participantes.splice(i, 1);
          this.qtdParticipantes = this.participantes.length;
          this.isLoading = false;
        }
      } else {
        this.isLoading = false;
        this.$swal.fire({
          position: "center",
          type: "warning",
          title: "Aviso",
          text: "É necessário ter pelo menos um participante.",
          showConfirmButton: true,
        });
      }
    }
  },
};
</script>
